import { useMutation } from "@shared/lib/hooks";
import { BriefService } from "../services/brief.service";
import {
  BRIEF_INFLUENCER_V2_SEARCH_QUERY_KEY,
  makeBriefInfluencerQueryKey,
  makeBriefSingleInfluencerQueryKey,
} from "@entities/brief/lib/constants";
import { ToastService } from "@shared/lib/services";
import { List, Modal, Space, Tag, Typography } from "antd";
import { IBriefInfluencerV2 } from "@shared/lib/types/briefInfluencerV2";
import { Button } from "@shared/ui/Button";
import { getPlatformIcon } from "@shared/lib/utils/getPlatformIcon";
import { getInfoDetails } from "@entities/influencer/lib/utils/getInfoDetails";
const { Text } = Typography;

export function useAskInfluencerCommercial(
  briefInfluencers: IBriefInfluencerV2[]
) {
  const {
    mutate: askInfluencerCommercial,
    isLoading: isAsking,
    isSuccess: isAsked,
  } = useMutation({
    mutationFn: ({
      briefInfluencerId,
      targetInfluencerCost,
    }: {
      briefInfluencerId: string;
      targetInfluencerCost?: number;
    }) =>
      BriefService.askInfluencerCommercial(
        briefInfluencerId,
        targetInfluencerCost
      )
        .then((res: any) => {
          if (res.statusCode === 202) {
            Modal.error({
              title: "Influencer commercials Error",
              okButtonProps: {
                type: "primary",
                style: {
                  background: "#33312F",
                },
              },
              content: (
                <List
                  dataSource={(
                    res.data as {
                      briefInfluencerId: string;
                      reason: string;
                      status: "failed" | "success";
                    }[]
                  ).filter((item) => item.status === "failed")}
                  renderItem={(item) => {
                    const influencer = briefInfluencers.find(
                      (influencer) => influencer._id === item.briefInfluencerId
                    );
                    return (
                      <List.Item>
                        <List.Item.Meta
                          title={
                            <Space>
                              <Space align="center">
                                <Button
                                  style={{ padding: 0 }}
                                  type="link"
                                  onClick={() => {
                                    window.open(
                                      influencer?.socialMedia?.link,
                                      "_blank"
                                    );
                                  }}
                                >
                                  {getPlatformIcon(
                                    influencer?.socialMedia?.platform || ""
                                  )}
                                  <Text strong>
                                    {influencer?.socialMedia?.username}
                                  </Text>
                                </Button>
                              </Space>
                              {influencer?.primaryContact?.agencyUserId && (
                                <Tag color="blue">
                                  {getInfoDetails(influencer).agency}
                                </Tag>
                              )}
                            </Space>
                          }
                          description={item.reason}
                        />
                      </List.Item>
                    );
                  }}
                />
              ),
            });
          }
        })
        .catch(async (err) => {
          const responseBody = await err.response.json();
          ToastService.error(responseBody.msg);
          throw err;
        }),
    options: {},
    onSuccess: (c, data) => {
      ToastService.success("Influencer commercial requested successfully");

      c.invalidateQueries({
        queryKey: [...BRIEF_INFLUENCER_V2_SEARCH_QUERY_KEY],
      });
    },
  });
  return {
    askInfluencerCommercial,
    isAsking,
    isAsked,
  };
}
